import {useMediaQuery} from '@uidotdev/usehooks'

export const useScreenSize = () => {
  const isMobile = useMediaQuery('only screen and (max-width : 480px)')
  const isLessThanTabletPortrait = useMediaQuery('only screen and (max-width : 767px)')
  const isTabletPortrait = useMediaQuery(
    'only screen and (min-width : 481px) and (max-width : 768px)',
  )
  const isLessThanTabletLandscape = useMediaQuery('only screen and (max-width : 1279px)')
  const isTabletLandscape = useMediaQuery(
    'only screen and (min-width : 769px) and (max-width : 1279px)',
  )
  const isDesktopDown = useMediaQuery('only screen and (max-width : 1279px)')
  const isDesktop = useMediaQuery('only screen and (min-width : 1280px)')

  return {
    isMobile,
    isLessThanTabletPortrait,
    isTabletPortrait,
    isLessThanTabletLandscape,
    isTabletLandscape,
    isDesktopDown,
    isDesktop,
  }
}
